import type { AuthSlice } from "@core/features/auth";

/**
 * Feature flags that can be toggled per app.
 * Apps set initial values when creating their store.
 */
export type FeatureFlags = {
  isSignupDisabled: boolean;
  isChatDisabled: boolean;
  isAddToCalendarDisabled: boolean;
  isWorkbookDownloadDisabled: boolean;
  isTranscriptionDisabled: boolean;
  isSupportPageDisabled: boolean;
};

/**
 * Default feature flags - apps can override these.
 */
export const defaultFeatureFlags: FeatureFlags = {
  isSignupDisabled: true,
  isChatDisabled: true,
  isAddToCalendarDisabled: false,
  isWorkbookDownloadDisabled: false,
  isTranscriptionDisabled: false,
  isSupportPageDisabled: true,
};

/**
 * App slice - handles app lifecycle and feature flags.
 * Shared by all apps.
 */
export type AppSlice = {
  // State
  isLoading: boolean;
  isHydrated: boolean;
  featureFlags: FeatureFlags;
  alertMessage: string | undefined;

  // Actions
  setLoading: (loading: boolean) => void;
  setHydrated: (hydrated: boolean) => void;
  setFeatureFlag: (flag: keyof FeatureFlags, value: boolean) => void;
  setAlertMessage: (message: string | undefined) => void;
  reset: () => void;
};

/**
 * Base app store - combines auth and app slices.
 * All app stores extend this type.
 */
export type BaseAppStore = AuthSlice & AppSlice;
